import { useEffect } from 'react';

import validate from './ClubStaffAddFormValidation';

import { COACH_ORG_ROLE_FIELD_NAME } from '../../../../utils/ClubConstants';

import useOrgRoleStaffRoleHierarchyData from '@usas/ui-web/state/orgRoleStaffRoleHierarchy/UseOrgRoleStaffRoleHierarchyData';

import useForm from '@usas/ui-web/utils/UseForm';
import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';
import HierarchicalDataUtils from '@usas/ui-web/utils/HierarchicalDataUtils';

const coachTypeCodeOptions = [
  { id: 'F', name: "Full Time" },
  { id: 'P', name: "Part Time" }
];

const INITIAL_FORM_STATE = {
  personId: '',
  memberId: '',
  coachTypeCode: coachTypeCodeOptions[0].id,
  coachTypeCodeName: coachTypeCodeOptions[0].name,
  personOrgRole: [],
  hasCoachRole: false,
  registrationRoleGroupId: DEFAULT_ID
};

const useClubStaffAddForm = (onSubmitFormCallback, registrationRoleGroupId, onIsDirtyChanged, onErrorCaught) => {
  const { orgRoleStaffRoleHierarchyState } = useOrgRoleStaffRoleHierarchyData();
  const { formState, errorState, isDirty, setFormData, handleSubmit, updateFormState, setIsDirty,
    onValueTextPairChanged, setErrors
  } = useForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  const onPersonOrgRoleChanged = (personOrgRole) => {
    const hasCoachRole = getHasCoachRole(personOrgRole);

    setFormData({
      ...formState,
      personOrgRole,
      hasCoachRole
    });
    setIsDirty(true);
  };

  useEffect(() => {
    try {
      if (registrationRoleGroupId) {
        setFormData({
          ...formState,
          registrationRoleGroupId
        });
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrationRoleGroupId]);

  useEffect(() => {
    try {
      if (onIsDirtyChanged) {
        onIsDirtyChanged(isDirty);
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : setErrors({ formError: e?.message });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty]);

  function getHasCoachRole(personOrgRole) {
    for (const role of personOrgRole) {
      const targetRole = HierarchicalDataUtils.FindNodeById(role.id, orgRoleStaffRoleHierarchyState.arrayData);

      if (Array.isArray(targetRole?.orgRoleField) && targetRole.orgRoleField.some(x => x.fieldName === COACH_ORG_ROLE_FIELD_NAME)) {
        return true;
      }
    }

    return false;
  }

  return {
    isDirty,
    formState,
    errorState,
    setFormData,
    handleSubmit,
    updateFormState,
    onValueTextPairChanged,
    onPersonOrgRoleChanged,
    coachTypeCodeOptions
  };
};

export default useClubStaffAddForm;